import React from "react";
import Lottie from "lottie-react";
import successAnimation from "../assets/88860-success-animation.json";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "../style.css";

export default function Posted() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <Lottie
        animationData={successAnimation}
        loop={false}
        style={{ width: "40%" }}
      />
      <div className="mt-5 text-DarkBlue font-medium">
        The article was published successfully!
      </div>
      <NavLink
        to="/homepage"
        className="bg-inputLabel text-white text-sm font-medium p-2 rounded-md mt-3 transition ease-in-out hover:scale-110 duration-300"
      >
        Go To Homepage
      </NavLink>
    </div>
  );
}
